/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramConfigsControllerFindOneByKeyQueryResponse,
  TelegramConfigsControllerFindOneByKeyPathParams,
} from '../types/TelegramConfigsControllerFindOneByKey.ts';

function getTelegramConfigsFindOneByKeyUrl(key: TelegramConfigsControllerFindOneByKeyPathParams['key']) {
  const res = { method: 'GET', url: `/api/telegram/configs/${key}` as const };
  return res;
}

/**
 * {@link /api/telegram/configs/:key}
 */
export async function telegramConfigsFindOneByKey(
  key: TelegramConfigsControllerFindOneByKeyPathParams['key'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramConfigsControllerFindOneByKeyQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getTelegramConfigsFindOneByKeyUrl(key).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
